import { analysisOneDimTableBuilder } from './BAnalysisOneDimTable'

export const BAnalysisBarTable = analysisOneDimTableBuilder('BAnalysisBarTable')
